<script>
  import moment from 'moment';
  export default {
    props: {
      isAdmin: {
        type: Boolean,
        default: false,
      },

      isAuthor: {
        type: Boolean,
        default: false,
      },

      isPeerReviewer: {
        type: Boolean,
        default: false,
      },

      courseId: {
        type: Number,
        default: null,
      },

      gradeLevels: {
        type: Array,
        default: null,
      },

      programs: {
        type: Array,
        default: null,
      },

      resourceTypes: {
        type: Array,
        default: null,
      },
    },

    methods: {
      formatDate(date) {
        if (!date) return null;
        return moment(date).format('MM/DD/YYYY');
      },

      parseDate(date) {
        if (!date) return null;

        const [month, day, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      },
    },
  };
</script>